webpackJsonp([1,2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(42)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(75),
  /* template */
  __webpack_require__(35),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = {
  install: function install(Vue) {
    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
    var options = arguments[2];

    Vue.prototype.$toast = function () {
      var _this = this;

      var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "默认的提示信息";
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { type: 'error' };

      var bgColor = 'rgba(0,0,0,.8)';
      var iconType = 'fa-exclamation-circle';
      if (options.type === 'success') {
        iconType = 'fa-check';
        bgColor = '#51a351';
      }
      var styleForOuter = 'position: fixed;display: flex;top: 0;left: 0;' + 'width: 100%;height: 100%;justify-content: center;align-items: center;z-index: 9999';
      var styleForInner = 'background: ' + bgColor + '; max-width: 250px; display: flex; padding: 15px; position: relative; overflow: hidden; border-radius: 5px; opacity: 1; transition: opacity .5s linear';
      var htmlForInner = '\n\t      <div style="flex: 1; color: #ffffff">' + text + '</div>\n\t\t\t';
      var outerDiv = document.createElement('div');
      outerDiv.style = styleForOuter;
      var innerDiv = document.createElement('div');
      innerDiv.style = styleForInner;
      innerDiv.innerHTML = htmlForInner;
      outerDiv.appendChild(innerDiv);
      this.$root.$el.appendChild(outerDiv);

      setTimeout(function () {
        innerDiv.style.opacity = 0;
      }, duration);
      setTimeout(function () {
        _this.$root.$el.removeChild(outerDiv);
      }, duration + 500);
    };
  }
};

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__header_vue__);





__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('cHead', __WEBPACK_IMPORTED_MODULE_1__header_vue___default.a);

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);


__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('dateFormat', function (value) {
  if (!value) return;
  return value.toString().substr(0, 10);
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Hello__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_Hello__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_views_home__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_views_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_views_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_views_about__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_views_about___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_views_about__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_views_news__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_views_news___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_views_news__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_views_newsView__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_views_newsView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_views_newsView__);









__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router___default.a);

/* harmony default export */ __webpack_exports__["a"] = new __WEBPACK_IMPORTED_MODULE_1_vue_router___default.a({
  routes: [{
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_3_views_home___default.a,
    meta: {
      back: false,
      menu: true,
      logo: true
    }
  }, {
    path: '/about',
    name: 'about',
    component: __WEBPACK_IMPORTED_MODULE_4_views_about___default.a,
    meta: {
      menu: true,
      title: '关于我们'
    }
  }, {
    path: '/news',
    name: 'news',
    component: __WEBPACK_IMPORTED_MODULE_5_views_news___default.a,
    meta: {
      menu: true,
      title: '新闻'
    }
  }, {
    path: '/news/view/:id',
    name: 'newsView',
    component: __WEBPACK_IMPORTED_MODULE_6_views_newsView___default.a,
    meta: {
      back: true
    }
  }]
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);


__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex___default.a);

var allStore = new __WEBPACK_IMPORTED_MODULE_1_vuex___default.a.Store({
    state: {
        menuStatus: false
    },
    getters: {
        getMenuStatus: function getMenuStatus(state) {
            return state.menuStatus;
        }
    },
    mutations: {
        clickMenu: function clickMenu(state) {
            state.menuStatus = !state.menuStatus;
        }
    },
    actions: {
        clickMenu: function clickMenu(_ref) {
            var commit = _ref.commit;

            commit('clickMenu');
        }
    }
});

/* harmony default export */ __webpack_exports__["a"] = allStore;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/campus-home.9d56315.png";

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(39)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(76),
  /* template */
  __webpack_require__(31),
  /* scopeId */
  "data-v-2db87fb8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(30),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(78),
  /* template */
  __webpack_require__(32),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(79),
  /* template */
  __webpack_require__(38),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(36),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(40)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(81),
  /* template */
  __webpack_require__(33),
  /* scopeId */
  "data-v-466754df",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(43)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(82),
  /* template */
  __webpack_require__(37),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(41)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(34),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dialogs"
  }, [_c('div', {
    staticClass: "dialog",
    class: {
      'dialog-active': _vm.show
    }
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [_c('div', {
    staticClass: "close rotate"
  }, [_c('span', {
    staticClass: "fa fa-times",
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _vm._t("header"), _vm._v(" "), _vm._t("body"), _vm._v(" "), _vm._t("footer")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-overlay"
  })])
},staticRenderFns: []}

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('h2', [_vm._v("Essential Links")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Ecosystem")]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("Core Docs")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://forum.vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("Forum")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://gitter.im/vuejs/vue",
      "target": "_blank"
    }
  }, [_vm._v("Gitter Chat")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://twitter.com/vuejs",
      "target": "_blank"
    }
  }, [_vm._v("Twitter")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vuejs-templates.github.io/webpack/",
      "target": "_blank"
    }
  }, [_vm._v("Docs for This Template")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://router.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vue-router")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vuex.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vuex")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vue-loader.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vue-loader")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/vuejs/awesome-vue",
      "target": "_blank"
    }
  }, [_vm._v("awesome-vue")])])])
}]}

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header"
  }, [(_vm.showLogo) ? _c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(21)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showBack) ? _c('span', {
    staticClass: "back",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("返回")]) : _vm._e(), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$route.meta.title))]), _vm._v(" "), (_vm.showMenu) ? _c('div', {
    staticClass: "close",
    on: {
      "click": _vm.clickMenu
    }
  }, [_c('span', {
    staticClass: "close-icon",
    class: {
      'open': _vm.menuStatus
    }
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('c-head'), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view-content"
  }, [_c('div', {
    staticClass: "home-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(20)
    }
  })])])
}]}

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newsview page-news-view"
  }, [_c('c-head'), _vm._v(" "), _c('div', {
    staticClass: "view-content"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.topic.title))]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("发布于：" + _vm._s(_vm._f("dateFormat")(_vm.topic.create_at)))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "main",
    domProps: {
      "innerHTML": _vm._s(_vm.topic.content)
    }
  }), _vm._v(" "), (_vm.noData) ? _c('div', {
    staticClass: "no-data"
  }, [_vm._v("没有相关内容！")]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('transition', {
    attrs: {
      "name": _vm.transName
    }
  }, [_c('router-view', {
    staticClass: "view"
  })], 1)], 1), _vm._v(" "), _c('menulist', {
    attrs: {
      "is-show": _vm.menuStatus
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aboutview"
  }, [_c('c-head'), _vm._v(" "), _c('div', {
    staticClass: "nav"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('span', {
      class: {
        'active': _vm.tabIndex === index
      },
      on: {
        "click": function($event) {
          _vm.tab(index)
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  })), _vm._v(" "), _c('div', {
    staticClass: "view-content"
  }, [_c('div', {
    staticClass: "nav-content",
    domProps: {
      "innerHTML": _vm._s(_vm.article)
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newsview page-news"
  }, [_c('c-head'), _vm._v(" "), _c('div', {
    staticClass: "view-content"
  }, [_c('ul', {
    staticClass: "newsList"
  }, _vm._l((_vm.topics), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.go(item.id)
        }
      }
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm._f("dateFormat")(item.create_at)))])])
  })), _vm._v(" "), _c('dialog', {
    attrs: {
      "show": _vm.show
    }
  }, [_c('header', {
    staticClass: "dialog-header",
    slot: "header"
  }, [_c('h1', {
    staticClass: "dialog-title"
  }, [_vm._v("提示信息")])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "body"
  }, [_c('p', [_vm._v("你想在对话框中放什么内容都可以！")]), _vm._v(" "), _c('p', [_vm._v("你可以放一段文字，也可以放一些表单，或者是一些图片。")])]), _vm._v(" "), _c('footer', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('button', {
    staticClass: "c-btn",
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("关闭")])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.isShow) ? _c('div', {
    staticClass: "menu",
    attrs: {
      "transition": "menu"
    }
  }, [_c('ul', [_c('li', {
    class: {
      'active': _vm.$route.name == 'home'
    },
    on: {
      "click": _vm.clickMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        'name': 'home'
      }
    }
  }, [_vm._v("首页")])], 1), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.$route.name == 'about'
    },
    on: {
      "click": _vm.clickMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        'name': 'about'
      }
    }
  }, [_vm._v("关于")])], 1), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.$route.name == 'news'
    },
    on: {
      "click": _vm.clickMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        'name': 'news'
      }
    }
  }, [_vm._v("新闻")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isShow) ? _c('div', {
    staticClass: "menu-mask",
    attrs: {
      "transition": "mask"
    },
    on: {
      "click": _vm.clickMenu
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 39 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 40 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 41 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 42 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 43 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menu_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_menu_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex__);






/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      transName: 'slideLeft'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({
    menuStatus: 'getMenuStatus'
  })),
  created: function created() {
    var _this = this;

    this.$router.beforeEach(function (to, from, next) {
      var len = to.path.split('/').length;
      var fLen = from.path.split('/').length;
      if (len > 2) {
        _this.transName = 'slideRight';
      }
      if (len < 3 && fLen < 3) {
        _this.transName = 'slideRight';
      }
      next();
    });
    this.$router.afterEach(function (to, from) {
      var len = to.path.split('/').length;
      var fLen = from.path.split('/').length;
      _this.transName = 'slideLeft';
      if (len > 2) {
        _this.transName = 'slideRight';
      }
      if (len < 3 && fLen < 3) {
        _this.transName = 'slideRight';
      }
    });
  },

  methods: {
    go: function go(route) {
      this.$router.push(route);
    }
  },
  components: {
    menulist: __WEBPACK_IMPORTED_MODULE_1__components_menu_vue___default.a
  }
};

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  },
  created: function created() {
    console.log(333333333333);
  }
};

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  props: {
    show: {
      default: false,
      type: Boolean,
      twoWay: true
    }
  },
  methods: {
    close: function close() {
      this.show = false;
    }
  }
};

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);





/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    showBack: function showBack() {
      return !this.$route.meta || this.$route.meta.back;
    },
    showMenu: function showMenu() {
      return !this.$route.meta || this.$route.meta.menu;
    },
    showLogo: function showLogo() {
      return !this.$route.meta || this.$route.meta.logo;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    menuStatus: 'getMenuStatus'
  })),
  created: function created() {},

  methods: {
    back: function back() {
      if (this.$route.name == 'about' || this.$route.name == 'news') {
        this.$router.push({ name: 'home' });
      } else {
        history.back(-1);
      }
      if (this.menuStatus) {
        this.clickMenu();
      }
    },
    clickMenu: function clickMenu() {
      this.$store.dispatch('clickMenu');
    }
  }
};

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
    data: function data() {
        return {};
    },

    props: {
        isShow: {
            default: false,
            type: Boolean
        }
    },
    methods: {
        clickMenu: function clickMenu() {
            this.$store.dispatch('clickMenu');
        }
    }
};

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      items: [{
        title: '简介',
        content: '<p>饿了么是中国专业的到家服务平台，2009年创立于上海。 饿了么成立至今，秉承极致、激情、创新的企业文化，致力推进中国餐饮业的数字化进程，让7亿城镇居民实现“美好生活，触手可得”。 截止2016年8月，公司员工超过15000人，在线外卖交易平台已覆盖全国1000多个城市，用户量超过7000万，加盟餐厅近60万家，日交易额突破1.6亿元，日订单量突破500万单，平台上超过99.5%的交易额来自移动端。</p><p>饿了么正改变着人们的饮食消费习惯乃至生活方式，定义到家消费的未来，努力向广大城镇居民兑现“美好生活，触手可得”的承诺。其在外卖交易平台、即时配送物流平台及供应链平台上的持续发力<p>在线外卖交易是饿了么的核心业务，主要从事用户和商户的交易撮合，目前已发展为全品类外卖平台，覆盖从早餐到夜宵的所有订餐时段及不同档次的餐饮品类。饿了么自主研发的Napos系统，是国内最早的外卖订单后台管理系统之一，为外卖商家带来极大的便利，推动了餐饮业的互联网化。</p><p>物流是外卖服务的基础。2015年8月，饿了么建立外卖行业首个即时配送物流平台，旨在搭建全国性的即时配送网络。物流平台包括自营配送团队、第三方加盟团队以及社会化众包配送。截止2016年7月，配送日处理订单高达260万单，配送人员达130万人，覆盖全国1000多个城市。其中，饿了么自配送团队已经在上海、北京、广州等25个一二线城市覆盖有300多个配送站点，并与30000多家品牌餐厅展开合作，专职配送员超过6000人，标准配送人效达每人每天35单，居业界领先地位。<p>'
      }, {
        title: '生活',
        content: '<p>生活多么美丽！</p>'
      }, {
        title: '环境',
        content: '<p>快乐你我他！</p>'
      }],

      tabIndex: 0,
      article: ''
    };
  },

  computed: {},
  created: function created() {
    this.article = this.items[0].content;
  },

  route: {
    data: function data() {}
  },
  methods: {
    tab: function tab(_index) {
      this.tabIndex = _index;
      this.article = this.items[_index].content;
    }
  },
  components: {}
};

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {};
  },
  created: function created() {},

  components: {}
};

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_js_util__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialog_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_dialog_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_webpack_zepto__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_webpack_zepto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_webpack_zepto__);






/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      show: false,
      nCount: 0,
      isShow: false,
      searchKey: '',
      topics: []
    };
  },

  components: {
    dialogBox: __WEBPACK_IMPORTED_MODULE_1__components_dialog_vue___default.a
  },
  created: function created() {
    this.getData();
  },

  methods: {
    go: function go(id) {
      this.$parent.go({
        'name': 'newsView',
        params: {
          id: id
        }
      });
    },
    tip: function tip() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__assets_js_util__["a" /* toast */])('提示窗口！');
    },
    closeDialog: function closeDialog() {
      this.show = false;
    },
    openDialog: function openDialog() {
      this.show = true;
      this.isShow = true;
    },
    getData: function getData() {
      var _this = this;

      var params = __WEBPACK_IMPORTED_MODULE_2_webpack_zepto___default.a.param(this.searchKey);
      __WEBPACK_IMPORTED_MODULE_2_webpack_zepto___default.a.get('https://cnodejs.org/api/v1/topics?' + params, function (d) {
        if (d && d.data) {
          _this.topics = d.data;
        }
      });
    }
  }
};

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_webpack_zepto__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_webpack_zepto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_webpack_zepto__);




/* harmony default export */ __webpack_exports__["default"] = {
    data: function data() {
        return {
            id: '',
            title: '',
            content: '',
            topicId: '',
            noData: false,
            topic: ''
        };
    },

    computed: {},
    created: function created() {
        var _this = this;

        this.topicId = this.$route.params.id;
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0_webpack_zepto___default.a.get('https://cnodejs.org/api/v1/topic/' + this.topicId, function (d) {
                if (d && d.data) {
                    _this2.topic = d.data;
                } else {
                    _this2.noData = true;
                }
            });
        }
    }
};

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toast; });


var toast = function toast(msg) {
  var handler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2000;

  var tip = new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
    data: {
      msg: msg,
      isShow: false
    },
    template: '<div class="cp-toast" v-show="isShow"><table><tr><td><span class="msg">{{msg}}</span></td></tr></table></div>',
    created: function created() {
      var _this = this;
      this.isShow = true;
      if (duration != 'forever') {
        setTimeout(function () {
          document.body.removeChild(_this.$mount().$el);
          _this.isShow = true;
        }, duration);
      }
    },
    destroyed: function destroyed() {
      handler();
    }
  });
  document.body.appendChild(tip.$mount().$el);
};

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_user__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filters__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_js_toast__ = __webpack_require__(15);









__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6__assets_js_toast__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__vuex_user__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ })
],[85]);


// WEBPACK FOOTER //
// static/js/app.48eda8b7e8a74e34d48d.js